module.exports = __webpack_public_path__ + "static/media/Illus-Employee_3@3x.3d0a1c34.png";